import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_1",
  "use": "icon-project_1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-project_1\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12.33,5.78H19.2a.85.85,0,0,1,.8.89V19.11a.85.85,0,0,1-.8.89H4.8a.85.85,0,0,1-.8-.89V4.89A.85.85,0,0,1,4.8,4h5.93Zm6.07,5.33H5.6v7.11H18.4Zm0-1.78V7.56H11.67l-1.6-1.78H5.6V9.33Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol